import { Record } from 'immutable';
const defaultContractManagerProps = {
  name: '',
  email: ''
};
class ContractManager extends Record(defaultContractManagerProps, 'ContractManager') {}
ContractManager.fromJS = obj => new ContractManager(Object.assign({}, obj));
export default ContractManager;